import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsGetUsersCount = z.any()
export type TagsGetUsersCount = z.infer<typeof tagsGetUsersCount>

export const descriptionGetUsersCount = z.any()
export type DescriptionGetUsersCount = z.infer<typeof descriptionGetUsersCount>

export const querystringGetUsersCount = z.object({ "page": z.string().optional(), "perPage": z.string().optional() })
export type QuerystringGetUsersCount = z.infer<typeof querystringGetUsersCount>

export const responseGetUsersCount = z.object({ "payload": z.object({ "count": z.number() }).optional(), "errors": z.any(), "message": z.string().optional() })
export type ResponseGetUsersCount = z.infer<typeof responseGetUsersCount>

interface IGetUsersCount extends BaseMethodType {
  tags: TagsGetUsersCount,
  description: DescriptionGetUsersCount,
  querystring: QuerystringGetUsersCount,
  response: ResponseGetUsersCount
}
export const URL = '/users/count'
export const validation = {
  get: {
    tags: tagsGetUsersCount,
    description: descriptionGetUsersCount,
    querystring: querystringGetUsersCount,
    response: responseGetUsersCount
  }
}
export interface UsersCount extends BaseRouteType {
  get: IGetUsersCount
}